import React from 'react'
import PlainHero from '../component/PlainHero/PlainHero'
import Footer from '../component/Footer/Footer'

function TermsCondition() {
  return (
    <div>
         <PlainHero
            Heading="Terms Condition"
            fontDark={true}
        />

<div className='container py-5'>
    <p className='body-paragraph fw-bold'>Effective Date: April 1st 2026</p>
    
    <p className='body-paragraph'>Welcome to Halton Surface Systems (“HSS”, “we”, “our”, or “us”). By accessing or using our website, you agree to the following Terms and Conditions. If you do not agree, please do not use this site.</p>

    <h3 className='content-heading'>1. Use of Website</h3>
    <p className='body-paragraph'>This website is intended to provide general information about our services, including architectural surface film installation and design solutions. You agree to use this site only for lawful purposes and in a way that does not infringe on the rights of others.</p>

    <h3 className='content-heading'>2. No Professional Advice</h3>
    <p className='body-paragraph'>All content on this website is provided for general informational purposes only and does not constitute professional, construction, or design advice. Project-specific recommendations require a formal consultation and site assessment.</p>

    <h3 className='content-heading'>3. Quotes & Estimates</h3>
    <p className='body-paragraph'>Any pricing, estimates, or timelines provided through the website, email, or phone are non-binding until confirmed through a written agreement signed by both parties.</p>

    <h3 className='content-heading'>4. Intellectual Property</h3>
    <p className='body-paragraph'>All content on this website, including text, images, logos, and branding, is the property of Halton Surface Systems unless otherwise stated. You may not reproduce, distribute, or use any content without prior written consent.</p>

    <h3 className='content-heading'>5. Third-Party Products, Brands & Visual Content</h3>
    <p className='body-paragraph'>We may reference or feature third-party brands, products, and manufacturers (including but not limited to architectural surface materials and design solutions) for informational and illustrative purposes.</p>
    <p className='body-paragraph'>Halton Surface Systems (“HSS”) and MES Décors operate as independent service providers. Any references to third-party brands do not constitute ownership, authorship, or direct affiliation unless explicitly stated.</p>
    
    <h5 className='fw-bold my-3'>Visual Content Disclaimer</h5>
    <p className='body-paragraph'>Images, renderings, and videos displayed on this website are intended to demonstrate the types of finishes, applications, and design possibilities achievable using the products and services we offer. These visuals are used to illustrate capabilities, inspiration, and potential outcomes, and do not necessarily represent actual projects completed by HSS or MES Décors.</p>
    
    <p className='body-paragraph'>Some visuals may include or showcase products, designs, or installations associated with third-party companies, including but not limited to: Mario Romano Walls / Solid Carved Surfaces, Elastron Fabrics / DJ Design, and 3M DI-NOC™. Such content remains the property of its respective owners and is used for reference and illustrative purposes only.</p>

    <h5 className='fw-bold my-3'>No Representation or Affiliation</h5>
    <p className='body-paragraph'>The inclusion of these materials does not imply that:</p>
    <ul className='list-unstyled body-paragraph ps-3'>
        <li>• The work shown was executed by HSS or MES Décors</li>
        <li>• HSS or MES Décors are certified, licensed, or officially affiliated with these brands (unless explicitly stated)</li>
        <li>• Any specific project depicted is part of our portfolio</li>
    </ul>

    <h5 className='fw-bold my-3'>No Guarantee of Identical Results</h5>
    <p className='body-paragraph'>Final results may vary depending on site conditions, materials, and project scope. HSS and MES Décors do not guarantee identical outcomes to those depicted in any visual materials. For verified project references or a portfolio of completed work, please contact us directly.</p>

    <h3 className='content-heading'>6. Limitation of Liability</h3>
    <p className='body-paragraph'>HSS is not liable for: Any direct or indirect damages arising from the use of this website, errors or omissions in content, or temporary unavailability of the website. Use of this website is at your own risk.</p>

    <h3 className='content-heading'>7. Links to Third-Party Websites</h3>
    <p className='body-paragraph'>Our website may contain links to external websites. We are not responsible for the content, policies, or practices of those sites.</p>

    <h3 className='content-heading'>8. Changes to Terms</h3>
    <p className='body-paragraph'>We reserve the right to update these Terms at any time. Continued use of the website constitutes acceptance of any changes.</p>

    <h3 className='content-heading'>9. Governing Law</h3>
    <p className='body-paragraph'>These Terms are governed by the laws of the Province of Ontario and applicable Canadian laws.</p>

    <h3 className='content-heading'>10. Contact Information</h3>
    <p className='body-paragraph mb-1'>For questions regarding these Terms, please contact:</p>
    <p className='body-paragraph fw-bold mb-0'>Halton Surface Systems</p>
    <p className='body-paragraph mb-0'>louay@haltonsurfacesystems.com</p>
    <p className='body-paragraph mb-0'>437-998-6650</p>

</div>
        <Footer/>
    </div>
  )
}

export default TermsCondition